import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {
    ERR_MSG,

} from "../constants/constants";



export const clrDownloadFileService = (url)=>{

    return new Promise((resolve,reject)=>{
        axiosInstance
            .get(url,{responseType: 'blob'})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                console.log(error)
                reject(ERR_MSG)
            });
    })
}